import MaterialsList from '../components/materials/MaterialsList'
import { createApp } from 'vue';
import { createPinia } from 'pinia'
import VideoModal from '../components/materials/VideoModal.vue'
import HowToRow from '../components/HowToRow.vue';
import PrintDropdown from '../components/PrintDropdown.vue';
import BaseCollapse from '../components/BaseCollapse.vue';

const pinia = createPinia();

if(document.getElementById('tips-and-materials-container')){
    const app = createApp({
        components: {
            MaterialsList,
            HowToRow,
            PrintDropdown,
            BaseCollapse
        }
    });

    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.use(pinia)
    app.mount('#tips-and-materials-container')
}

if(document.getElementById('tips-and-materials-video-modal-container')){
    const app2 = createApp({
        components: {
            VideoModal
        }
    });
    app2.use(pinia)
    app2.mount('#tips-and-materials-video-modal-container');
}


if(document.getElementById('tips-and-materials-search-video-modal-container')){
    const app3 = createApp({
        components: {
            VideoModal
        }
    });
    app3.use(pinia)
    app3.mount('#tips-and-materials-search-video-modal-container');
}